import React from 'react';

import { Root } from './style';

function ButtonGroup({ children }) {
  return <Root length={children.length}>{children}</Root>;
}

export default ButtonGroup;
